<template>
  <div :class="inputCssClass">
    <v-container class="pa-0 ma-0" text-xs-center>
      <v-layout row align-center>
        <v-flex>
          <v-select v-model="hourValue" :items="allowedHours" box label="Hora"></v-select>
        </v-flex>
        <v-flex><span class="title">:</span></v-flex>
        <v-flex>
          <v-select v-model="minuteValue" :items="allowedMinutes" box label="Minuto"></v-select>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    label: {
      type: String,
    },
    inputCssClass: {
      type: [Object, String],
    },
    value: {
      type: [String, Object, Number],
    },
    allowedHours: {
      type: [Array, Object],
      default() {
        const res = [];
        for (let i = 0; i < 24; i++) {
          const minute = ('0' + i).substr(-2);
          res.push(minute);
        }
        return res;
      },
    },
    allowedMinutes: {
      type: [Array, Object],
      default() {
        const res = [];
        for (let i = 0; i < 60; i++) {
          const minute = ('0' + i).substr(-2);
          res.push(minute);
        }
        return res;
      },
    },
    error: {
      type: String,
    },
  },
  data() {
    return {
      hourValue: this.value ? this.value.split(':')[0] : null,
      minuteValue: this.value ? this.value.split(':')[1] : null,
      menu: false,
    };
  },
  computed: {
    time() {
      if (this.hourValue && this.minuteValue) {
        return this.hourValue + ':' + this.minuteValue;
      } else {
        return null;
      }
    },
  },
  methods: {
    cancel() {
      this.menu = false;
      this.time = null;
    },
    allowedHoursComputed(t) {
      console.log('allowedHoursComputed', t, this.allowedHours);

      if (this.allowedHours && Array.isArray(this.allowedHours)) {
        return this.allowedHours.includes(String(t));
      } else {
        return true;
      }
    },
    allowedMinutesComputed(m) {
      console.log('allowedMinutesComputed', m, this.allowedMinutes);
      if (this.allowedMinutes && Array.isArray(this.allowedMinutes)) {
        return this.allowedMinutes.includes(String(m));
      } else {
        return true;
      }
    },
  },
  watch: {
    value: function(val, oldVal) {
      if (val) {
        this.hourValue = this.value.split(':')[0];
        this.minuteValue = this.value.split(':')[1];
      } else {
        this.hourValue = null;
        this.minuteValue = null;
      }
    },
    time: function(val, oldVal) {
      this.$emit('input', this.time);
    },
  },
};
</script>

<style></style>
